/**
 * Editable console settings (S05).
 *
 * Only the greeting so far. It lives here rather than on the agent because it is
 * *ours*: the platform preset's own first message greeted every contact by one
 * demo contact's surname, so the console sends `first_message` per call instead.
 * That makes the opening line console configuration that happens to be shown on
 * the agent page, not a field on the Sirma agent — which is why it saves through
 * its own endpoint and takes no part in the agent's conflict detection.
 */
import { z } from 'zod';

/**
 * A greeting is spoken aloud, so the cap is about how long somebody will listen
 * rather than about storage. Three hundred characters is already a long opening
 * for a cold call.
 */
export const GREETING_MAX = 300;

export const greetingSettingSchema = z.object({
  template: z.string(),
  /** True when no row has been saved and the deployed default is in use. */
  isDefault: z.boolean(),
  /** The default, so the editor can offer to restore it without hardcoding it. */
  defaultTemplate: z.string(),
  updatedAt: z.string().datetime().nullable(),
  updatedBy: z.string().nullable(),
});
export type GreetingSetting = z.infer<typeof greetingSettingSchema>;

/**
 * A change to the opening line.
 *
 * Trimmed and non-empty, because an empty first message means the agent opens
 * with silence and the contact hangs up. Missing placeholders are *not* rejected
 * — see `greetingWarnings` for why that is advice rather than validation.
 */
export const greetingUpdateSchema = z.object({
  template: z.string().trim().min(1).max(GREETING_MAX),
});
export type GreetingUpdate = z.infer<typeof greetingUpdateSchema>;
